module.exports = __webpack_public_path__ + "static/media/Localyser_Logo_Primary.e9a06930.png";